import React from 'react'

import { useTranslation } from 'next-i18next'

import { AuthError, ResetAuthPartFields } from '@dentalux/security'

import AuthLayout from 'src/components/AuthLayout'
import LinkButton from 'src/components/LinkButton/LinkButton'
import { useUnauthorizedContext } from 'src/components/providers/UnauthorizedProvider'
import SuccessView from 'src/components/SuccessView'
import usePrepareErrorMessage from 'src/hooks/usePrepareErrorMessage'

import ForgotPasswordForm from './components/ForgotPasswordForm'
import FormAppendage from './components/FormAppendage'

type Props = {
  onSubmit: (data: ResetAuthPartFields) => void
  onResendLink?: () => void
  processing?: boolean
  error?: AuthError
  success?: boolean
}

const ForgotPassword = ({ onSubmit, processing, error, success, onResendLink }: Props) => {
  const { t } = useTranslation()
  const { email } = useUnauthorizedContext()

  const errorMessage = usePrepareErrorMessage(error)

  const heading = success ? t('b2c.forgotPassowrd.headingSucess') : t('b2c.forgotPassowrd.heading')
  const subHeading = success ? t('b2c.forgotPassowrd.subheadingSuccess') : t('b2c.forgotPassowrd.subheading')

  return (
    <AuthLayout heading={heading} subHeading={subHeading} error={errorMessage}>
      {success && (
        <SuccessView spaceUnderAnimation>
          <LinkButton center onClick={onResendLink}>
            {t('b2c.forgot_password_form.resendEmail')}
          </LinkButton>
        </SuccessView>
      )}

      {!success && (
        <ForgotPasswordForm
          onSubmit={onSubmit}
          initialValues={{ email }}
          isLoading={processing}
          appendToForm={<FormAppendage />}
        />
      )}
    </AuthLayout>
  )
}

export default ForgotPassword
